// language=GraphQL
export const ALL_TESTIMONIALS_QUERY = `query Query($withContentBlock: Boolean = false, $withContentBlockImage: Boolean = false) {
  testimonials: travelTestimonials {
    id
    contentBlock @include(if: $withContentBlock) {
      id
      title
      text
      image @include(if: $withContentBlockImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      imagePosition
    }
  }
}`

// language=GraphQL
export const SINGLE_TESTIMONIAL_QUERY = `query Query($id: ID!, $withContentBlock: Boolean = false, $withContentBlockImage: Boolean = false) {
  testimonial: travelTestimonial(id: $id) {
    id
    contentBlock @include(if: $withContentBlock) {
      id
      title
      text
      image @include(if: $withContentBlockImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      imagePosition
    }
  }
}`

// language=GraphQL
export const CREATE_TESTIMONIAL_MUTATION = `
  mutation Mutation($input: CreateTravelTestimonialInput, $withContentBlock: Boolean = false, $withContentBlockImage: Boolean = false) {
    testimonial: createTravelTestimonial(input: $input) {
      id
      contentBlock @include(if: $withContentBlock) {
        id
        title
        text
        image @include(if: $withContentBlockImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        imagePosition
      }
    }
  }`

// language=GraphQL
export const UPDATE_TESTIMONIAL_MUTATION = `
  mutation Mutation($input: UpdateTravelTestimonialInput, $withContentBlock: Boolean = false, $withContentBlockImage: Boolean = false) {
    testimonial: updateTravelTestimonial(input: $input) {
      id
      contentBlock @include(if: $withContentBlock) {
        id
        title
        text
        image @include(if: $withContentBlockImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        imagePosition
      }
    }
  }`

// language=GraphQL
export const DELETE_TESTIMONIAL_MUTATION = `
  mutation Mutation($input: DeleteTravelTestimonialInput) {
    deleteTravelTestimonial(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_TESTIMONIAL_MUTATION = `
  mutation Mutation($input: DeleteTravelTestimonialInput) {
    forceDeleteTravelTestimonial(input: $input) {
      success
    }
  }`
// language=GraphQL
export const TESTIMONIALS_DEPENDENTS_QUERY = `query Query($id: ID!, $withTravels: Boolean = false) {
  groupedDependents: travelTestimonialDependents(id: $id) {
    travels @include(if: $withTravels) {
      id
      name
      isBestseller
      startDate
      endDate
      executionStatus
      title
      description
      introVideoUrl
      includedServices
      excludedServices
      pricingTable
      priceCalculationInfo
      programType
      programText
      minPrice
      minPriceManualOverride
      currency
    }
  }
}`
